// Helper chico y genérico: correr una tarea async por cada item de una
// lista, con a lo sumo `limite` en vuelo a la vez — sin librería aparte
// (mismo criterio "una función chica en vez de una dependencia nueva" del
// resto del proyecto). Usado por pdfCopiaHistoria.ts para paralelizar la
// descarga de los PDFs firmados (antes secuencial, uno por uno).
export async function mapConcurrente<T, R>(items: readonly T[], limite: number, fn: (item: T, indice: number) => Promise<R>): Promise<R[]> {
  const resultados: R[] = Array.from({ length: items.length });
  let siguiente = 0;
  async function trabajador(): Promise<void> {
    while (siguiente < items.length) {
      const indice = siguiente++;
      resultados[indice] = await fn(items[indice]!, indice);
    }
  }
  await Promise.all(Array.from({ length: Math.min(limite, items.length) }, trabajador));
  return resultados;
}
